export default "__VITE_ASSET__UiL_3J_h__"